// extracted by mini-css-extract-plugin
module.exports = {"links":"Footer_links__vscLy","social":"Footer_social__PMSlF"};